import {CustomerResponseBodyV2} from '@dms/api/customer';

import {Nullish} from 'shared/web';

const DRIVER_LICENCE_CARD_TYPE = 'ID_DRIVER_LICENSE';

export const getDriversLicenceNumber = (
  customer: CustomerResponseBodyV2 | Nullish
): string | undefined =>
  customer?.foundingPerson?.identityCards?.find((card) => card.type === DRIVER_LICENCE_CARD_TYPE)
    ?.cardNumber;
